/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  var TARGET_PRODUCT_ID = 10249014280479;
  var TARGET_VARIANT_ID = 51234117353759;
  var KIT_TITLE_PATTERNS = [/touch ?up kit/i, /personali[sz]e your kit/i];
  var KIT_URL = '/collections/palettes-and-custom-kit';
  var WARNING_LINK_TEXT = 'add a touch up kit';

  // Each rule maps a group of discount codes to the message shown for them.
  // Matching is case-insensitive: a code matches a rule when it contains any
  // of the rule's substrings. The first rule with a match wins.
  var DISCOUNT_RULES = [
    {
      id: '50-off',
      substrings: ['1/2PRICE', 'BRUSH50'],
      warningText: 'For the 50% off discount to work for these brushes, please ',
      linkText: WARNING_LINK_TEXT,
      linkUrl: KIT_URL
    },
    {
      id: 'free-brush-set',
      substrings: ['BRUSHLOVE'],
      warningText: 'For the Free Brush Set to work for these brushes, please ',
      linkText: WARNING_LINK_TEXT,
      linkUrl: KIT_URL
    }
  ];

  var STYLE_FLAG = 'data-brush-discount-styles';
  var WARNING_FLAG = 'data-brush-discount-warning';
  var WRAPPER_CLASS = 'brush-discount';

  function hasCartUi() {
    return !!document.querySelector('[data-cart-page], cart-drawer');
  }

  function injectStyles() {
    if (document.querySelector('[' + STYLE_FLAG + ']')) return;
    var style = document.createElement('style');
    style.setAttribute(STYLE_FLAG, '');
    style.textContent =
      '.' + WRAPPER_CLASS + '{margin-top:8px;}' +
      '.' + WRAPPER_CLASS + '__warning{display:inline-block;font-size:12px;line-height:1.4;color:#a13b00;}' +
      '.' + WRAPPER_CLASS + '__warning a{color:inherit;text-decoration:underline;}';
    document.head.appendChild(style);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function(res) { return res.json(); });
  }

  function findBrushesItem(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.product_id === TARGET_PRODUCT_ID || item.variant_id === TARGET_VARIANT_ID) {
        return item;
      }
    }
    return null;
  }

  function matchDiscountRule(cart) {
    var codes = (cart && cart.discount_codes) || [];
    var applied = [];
    for (var i = 0; i < codes.length; i++) {
      var entry = codes[i];
      if (entry && typeof entry.code === 'string') {
        applied.push(entry.code.toUpperCase());
      }
    }

    for (var r = 0; r < DISCOUNT_RULES.length; r++) {
      var rule = DISCOUNT_RULES[r];
      for (var c = 0; c < applied.length; c++) {
        for (var s = 0; s < rule.substrings.length; s++) {
          if (applied[c].indexOf(rule.substrings[s]) !== -1) return rule;
        }
      }
    }

    return null;
  }

  function hasKit(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var title = items[i] && items[i].product_title;
      if (typeof title !== 'string') continue;
      for (var j = 0; j < KIT_TITLE_PATTERNS.length; j++) {
        if (KIT_TITLE_PATTERNS[j].test(title)) return true;
      }
    }
    return false;
  }

  function findLineItemEls(key) {
    if (!key) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart__item[data-item="' + key + '"]')
    );
  }

  function removeAllInjected() {
    var nodes = document.querySelectorAll('.' + WRAPPER_CLASS);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].parentNode && nodes[i].parentNode.removeChild(nodes[i]);
    }
  }

  function renderWarningInto(lineEl, rule) {
    var host = lineEl.querySelector('.cart__item__content__left .cart__item__content-inner')
      || lineEl.querySelector('.cart__item__content__left')
      || lineEl.querySelector('.cart__item__content')
      || lineEl;

    var wrapper = lineEl.querySelector('.' + WRAPPER_CLASS);
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = WRAPPER_CLASS;
      host.appendChild(wrapper);
    }

    var warning = wrapper.querySelector('[' + WARNING_FLAG + ']');
    if (!warning) {
      warning = document.createElement('span');
      warning.setAttribute(WARNING_FLAG, '');
      warning.className = WRAPPER_CLASS + '__warning';
      wrapper.appendChild(warning);
    }

    if (warning.getAttribute('data-brush-discount-rule') === rule.id) return;
    warning.setAttribute('data-brush-discount-rule', rule.id);

    warning.textContent = '';
    var link = document.createElement('a');
    link.href = rule.linkUrl;
    link.textContent = rule.linkText;
    warning.appendChild(document.createTextNode(rule.warningText));
    warning.appendChild(link);
  }

  function removeStrayInjections(keepEls) {
    var nodes = document.querySelectorAll('.' + WRAPPER_CLASS);
    outer: for (var i = 0; i < nodes.length; i++) {
      for (var j = 0; j < keepEls.length; j++) {
        if (keepEls[j].contains(nodes[i])) continue outer;
      }
      nodes[i].parentNode && nodes[i].parentNode.removeChild(nodes[i]);
    }
  }

  function evaluate() {
    if (!hasCartUi()) return;

    fetchCart().then(function(cart) {
      var brushesItem = findBrushesItem(cart);
      var discountRule = matchDiscountRule(cart);
      var kitPresent = hasKit(cart);

      var shouldShow = !!brushesItem && !!discountRule && !kitPresent;
      if (!shouldShow) {
        removeAllInjected();
        return;
      }

      var lineEls = findLineItemEls(brushesItem.key);
      if (lineEls.length === 0) {
        removeAllInjected();
        return;
      }

      injectStyles();
      removeStrayInjections(lineEls);
      for (var i = 0; i < lineEls.length; i++) {
        renderWarningInto(lineEls[i], discountRule);
      }
    }).catch(function(err) {
      console.error('cart watcher error', err);
    });
  }

  if (hasCartUi()) {
    if (document.querySelector('[data-cart-page]')) {
      evaluate();
    }
    document.addEventListener('theme:cart:update', evaluate);
    document.addEventListener('theme:cart:refresh', evaluate);
    document.addEventListener('theme:cart:add', evaluate);
    document.addEventListener('theme:cart-drawer:open', evaluate);
  }
})();
